module.exports = __webpack_public_path__ + "media/images/fixed-border-e9882d80b0a3656ff41f71dac6b82026.png";